<template>
    <section class="px-4 py-14 pt-8 pb-8 mx-auto max-w-screen-2xl md:py-28 md-max:pb-20 md:pt-8 sm:px-10 lg:px-8" id="the-products">
        <div class="font-bold text-center text-38 text-lifeboost-orange-200 font-ww-medium">
            END OF SUMMER SALE
        </div>
        <div
            class="mx-auto mt-10 max-w-screen-lg font-bold text-center lg:px-32 md:mt-24 title-mushroom font-ww-medium text-lifeboost-gray-lighter">
            Get All-Day Energy and Focus With the Power of Healthy, Low-Acid Coffee Upgraded with High-Potency Real
            Mushrooms
        </div>

        <div class="mt-12 text-center leading-46 md:mt-16 md:px-10 text-40 font-ww-medium text-lifeboost-gray-lighter">
            Get <strong>72% Off</strong> the Cognition Coffee Starter Kit - Ends Soon!
        </div>

        <div class="grid grid-cols-12 mt-10 md:mt-24 lg:gap-x-24 md:gap-x-8 lg:mb-12">
            <div class="col-span-12 lg:col-span-6 md-max:-mx-2">
                <nuxt-img sizes="xs:272px sm:392px md:638px lg:416px xl:450px 2xl:520px"
                    src="/assets/images/product1111.jpg" alt="product with gift" class="" width="845" height="741"
                    format="webp" loading="lazy"></nuxt-img>
            </div>

            <div class="col-span-12 mx-auto mt-10 lg:col-span-6 md:mx-0 md:mt-0">
                <div class="space-y-12 md:space-y-12">
                    <div v-for="(item, index) in items" :key="index" class="flex gap-x-4 md:gap-x-6">
                        <div class="">
                            <nuxt-img :src="item.imgSrc" alt="checkbox" class="" width="47" height="47" format="webp"
                                loading="lazy"></nuxt-img>
                        </div>
                        <div
                            class="w-full leading-41 text-28 font-ww-medium text-lifeboost-gray-lighter">
                            <div class="" v-html="item.content">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap gap-y-4 gap-x-8 justify-center items-center py-4 pt-16 md:my-4 lg:justify-start">
                    <div class="-mt-1 text-42 text-lifeboost-gray-lighter"> <span
                            class="line-through font-ww-light">$214</span> <strong class="font-ww-medium">$59
                        </strong></div>
                    <div
                        class="flex items-center px-5 py-3 text-2xl text-white rounded-full bg-lifeboost-blue-300 font-ww-medium">
                        SAVE $155 TODAY
                    </div>
                </div>

             <div class="pt-4 lg:max-w-2xl lg:pr-12">
                <div class="flex justify-center lg:justify-start">
                    <button @click="addToCart" class="flex items-center w-full bnt-icon !px-12">
                        <span class="flex items-center">
                            Get started
                        </span>
                        <svg class="relative top-0.5 ml-4 w-8 sm:w-auto" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="38px" height="31px" viewBox="0 0 38 31" data-v-inspector="components/section/mushroomNewBuilder/IconsWithImagesSwiper.vue:87:21"><path fill-rule="evenodd" fill="rgb(255, 255, 255)" d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z" data-v-inspector="components/section/mushroomNewBuilder/IconsWithImagesSwiper.vue:89:25"></path></svg>
                    </button>
                </div>

                <div class="flex flex-wrap gap-x-6 gap-y-6 justify-center mt-5 md:mt-4 md:px-4 lg:justify-center">
                    <div class="flex gap-x-3 items-center">
                        <div class="">
                            <nuxt-img src="/assets/images/check122.png" alt="checkbox" class="pt-1" width="34" height="34"
                                format="webp" loading="lazy"></nuxt-img>
                        </div>
                        <div class="leading-8 text-30 text-lifeboost-orange-dark font-ww-medium">
                            30-Day Returns
                        </div>
                    </div>

                    <div class="flex gap-x-3 items-center">
                        <div class="">
                            <nuxt-img src="/assets/images/check122.png" alt="checkbox" class="pt-1" width="34" height="34"
                                format="webp" loading="lazy"></nuxt-img>
                        </div>
                        <div class="leading-8 text-30 text-lifeboost-orange-dark font-ww-medium">
                            Free Shipping
                        </div>
                    </div>
                </div>

                <div class="mt-12 md:mt-20 md:px-0">
                    <div class="text-33 text-lifeboost-gray-lighter font-ww-medium">
                        Refill ships in 30 days
                    </div>
                    <div class="mt-6 text-xl leading-8 md:leading-10 md:text-23 md:mt-8 text-lifeboost-gray-lighter font-ww-medium md:font-ww-regular">
                        Three days before your next billing and shipment, we'll send you a reminder email. Your order includes three bags of Lifeboost Cognition Mushroom Coffee. Your first order is $59, all future automatic orders are only $69. You can easily adjust or cancel your subscription at any time.
                    </div>
                </div>
             </div>
            </div>
        </div>
    </section>
</template>

<script setup>
const products = [
  {id:'42133448425532', qty: 1, price: 59.00 , title: 'Cognition Mushroom Ground coffee', selling_plan: 2052063292},
  {id:'40282477330492', qty: 1, price: 0.00 , title: 'Lifeboost Frother', selling_plan: null},
  {id:'42133501018172', qty: 1, price: 0.00 , title: 'Copper Lifeboost Coffee Scoops', selling_plan: null},
  {id:'42120155168828', qty: 1, price: 0.00 , title: 'The Ultimate Toxin-Free Living Guide - Digital eBook', selling_plan: null},
  {id:'39411358498876', qty: 1, price: 0.00 , title: '100 Espresso Recipes From Around The World - Digital Recipe eBook', selling_plan: null},
];
const sellingPlanId = await getSellingPlan('cognition-real-mushroom-coffee-subscription', '1 month subscription');
const cart = useCart();

function addToCart() {
   products.forEach(product => {
    if (product.selling_plan) product.selling_plan = sellingPlanId;
    cart.add(product);
  });
  //Discount Codes!
  cart.checkout("?discount=CRM-FS,CRM-DISCOUNT", true)
}

const items = [
    {
        imgSrc: '/assets/images/check122.png',
        content: '<span class="font-ww-regular">2X 12 oz. Bags of Lifeboost Cognition Coffee</span> <strong class="font-ww-medium">($96.66 Value)</strong>',
    },
    {
        imgSrc: '/assets/images/check122.png',
        content: '<strong>FREE</strong> Bonus Bag of Lifeboost Cognition Coffee <strong>($48.33 Value)</strong>',
    },
    {
        imgSrc: '/assets/images/check122.png',
        content: '<strong>FREE</strong> Shipping <strong>($10.00 Value)</strong>',
    },
    {
        imgSrc: '/assets/images/check122.png',
        content: '<strong>FREE</strong> Premium Frother <strong>($20.00 Value)</strong>',
    },
    {
        imgSrc: '/assets/images/check122.png',
        content: '<strong>FREE</strong> Toxin Guide <strong>($12.00 Value)</strong>',
    },
    {
        imgSrc: '/assets/images/check122.png',
        content: '<strong>FREE</strong> Coffee Spoon <strong>($15.00 Value)</strong>',
    },
    {
        imgSrc: '/assets/images/check122.png',
        content: '<strong>FREE</strong> Healthy Coffee Recipe Book <strong>($12.00 Value)</strong>',
    },
];

defineBuilderComponent({
    friendlyName: "TitleDescriptionsPrice",
});

</script>